import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { SHOP, waLink } from "@/lib/shop";
import { WhatsAppIcon } from "./WhatsAppIcon";

const LINKS = [
  { href: "#phones", label: "Phones for Sale" },
  { href: "#repairs", label: "Repairs" },
  { href: "#why", label: "Why Us" },
  { href: "#visit", label: "Visit Our Shop" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-ink/95 backdrop-blur-xl border-b border-white/10" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-display text-xl md:text-2xl font-black tracking-tight text-white">
            FONZ <span className="text-brand">FIX</span>4<span className="text-brand">U</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-semibold text-slate-300 hover:text-brand transition-colors" data-testid={`nav-link-${l.href.slice(1)}`}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <a href={`tel:${SHOP.phoneTel}`} className="inline-flex items-center gap-2 rounded-full border-2 border-white/20 px-4 py-2 text-sm font-semibold text-white hover:border-brand hover:text-brand transition-colors" data-testid="nav-call-btn">
            <Phone className="h-4 w-4" /> {SHOP.phoneDisplay}
          </a>
          <a href={waLink("Hi FONZ FIX4U, I have a question.")} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-semibold text-white hover:bg-[#20BD5A] transition-colors" data-testid="nav-whatsapp-btn">
            <WhatsAppIcon className="h-4 w-4" /> WhatsApp
          </a>
        </div>
        <button className="lg:hidden p-2 rounded-full text-white hover:bg-white/10" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-menu-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-ink px-4 py-4 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-3 px-2 font-display text-lg font-semibold text-white border-b border-white/10 hover:text-brand" data-testid={`mobile-nav-link-${l.href.slice(1)}`}>
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
